module.exports = __webpack_public_path__ + "media/images/frontend/heros/processes-bb86c6067ba404f8a2f3ece9334df960.jpg";